export const VERSION_TYPES = {
  'Nuevo': {
    label: 'Nuevo',
    icon: 'Plus',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    badgeColor: 'bg-emerald-500'
  },
  'Mejorado': {
    label: 'Mejorado',
    icon: 'Zap',
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    badgeColor: 'bg-blue-500'
  },
  'Corregido': {
    label: 'Corregido',
    icon: 'Bug',
    color: 'bg-orange-100 text-orange-800 border-orange-200',
    badgeColor: 'bg-orange-500'
  },
  'Removido': {
    label: 'Removido',
    icon: 'MinusCircle',
    color: 'bg-zinc-100 text-zinc-700 border-zinc-200',
    badgeColor: 'bg-zinc-500'
  }
} as const;

export type VersionTipo = keyof typeof VERSION_TYPES;
